import { computed } from 'vue'
import { useFeatureFlag } from '@/hooks/useFeatureFlags'
import { useUserPermission } from '@/hooks/usePermission'
import { useUserRoles } from '@/hooks/useUserRoles'

export const useCanUploadUsers = () => {
  const { isEnabled: isUserUploadEnabled } = useFeatureFlag(
    'enable_user_list_upload'
  )
  const { isAtLeastSuperuser } = useUserRoles()
  const { canWrite: canWriteUsers } = useUserPermission('users')

  const canUploadUsers = computed(
    () =>
      isUserUploadEnabled.value &&
      isAtLeastSuperuser.value &&
      canWriteUsers.value
  )

  return { canUploadUsers }
}
